module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_6000.980020b8.png";